import React from "react";
import SectionHeading from "../components/SectionHeading";
import ContactInfoCards from "../components/contact/ContactInfoCards";
import ContactForm from "../components/contact/ContactForm";

export default function ContactPage() {
    return (
        <div data-testid="contact-page" className="pt-36 pb-20">
            <div className="xpo-container">
                <SectionHeading
                    overline="Get in touch"
                    title="Let's talk markets, accounts, and execution."
                    description="Onboarding questions, partnership enquiries, or technical issues — our team is on chat and email 24/5."
                />

                <div className="grid lg:grid-cols-5 gap-10 mt-14">
                    <ContactInfoCards />
                    <ContactForm />
                </div>
            </div>
        </div>
    );
}
